module.exports = __webpack_public_path__ + "media/images/slide-2-5986a7ba2ffe0a9e47164fca28d08b19.png";